import { Redirect, Route, RouteProps } from 'react-router-dom'
import * as Routes from 'src/domain/routes'
import { isAuthenticated } from 'src/services/auth-service'

export const ProtectedRoute = ({ children, ...rest }: RouteProps) => {
    const returnTo = rest.location?.pathname
    return <Route {...rest} render={props => (isAuthenticated() ? <>{children}</> : <Redirect to={{ pathname: Routes.HomeRoute, state: returnTo }} />)} />
}
